import { takeLatest, select, put, all } from 'redux-saga/effects';
import {
  toggleIsSelectedAsComp,
  setTransientValuation, setTransientValuationInputs
} from 'store/actions';
import { transientValuationSelector, selectedOpportunityCompsSelector, selectedProformaInputsSelector } from 'store/selectors';

export function* toggleIsSelectedAsCompSaga() {
  yield takeLatest(toggleIsSelectedAsComp, function* ({ payload: compId }) {
    const [comps, transientValuation] = yield all([
      select(selectedOpportunityCompsSelector),
      select(transientValuationSelector)
    ]);

    const newTransientValuation = {
      ...transientValuation,
      valuationsComps: [...transientValuation.valuationsComps]
    };
    const foundComp = comps.find(c => c.id === compId);
    if (foundComp) {
      const foundCompIndex = newTransientValuation.valuationsComps.findIndex(vc => vc.compId === compId); // Check valuation's array of selected comps
      if (foundCompIndex === -1) {
        newTransientValuation.valuationsComps.push({ compId }); // Add comp if not previously selected
      } else {
        newTransientValuation.valuationsComps.splice(foundCompIndex, 1); // Remove comp if previously selected
      }
      yield put(setTransientValuation(newTransientValuation, false));
    }

    // Then update valuationInput and proforma input radio array
    let proformaInputToUpdate = null;
    switch (foundComp.compType) {
      case 0:
        proformaInputToUpdate = 'rents';
        break;
      case 2:
        proformaInputToUpdate = 'afterRepairValues';
        break;
      default:
        proformaInputToUpdate = null;
    }

    if (proformaInputToUpdate) { // Only update proforma inputs from comps if comp type is Rent or Sold, not For Sale
      const selectedProformaInputs = yield select(selectedProformaInputsSelector); // After setTransientValuation above, this will return latest calculated comp min/avg/max arrays
      const newValuationInput = { ...newTransientValuation.valuationInput };
      
      if (proformaInputToUpdate === 'rents' && newValuationInput.rentType !== 0) {  // If selected type is not UserDictate, update or clear transient valuation's rent value input, because comps selection change will result in rents radio array change  
        const foundInput = selectedProformaInputs[proformaInputToUpdate]?.find(input => input.type === newValuationInput.rentType); // Try to find the previously selected rentType in the newly update rents radio array
        if (foundInput) { // If found, update with the newly calculated value
          newValuationInput.rent = foundInput.value;
        } else { // If not found (i.e. user deselected all comps), clear both the value and type selection
          newValuationInput.rent = null;
          newValuationInput.rentType = null;
        } 
      }
      else if (proformaInputToUpdate === 'afterRepairValues' && newValuationInput.afterRepairValueType !== 0) { // If selected type is not UserDictate, update or clear transient valuation's afterRepairValue input, because comps selection change will result in afterRepairValues radio array change
        const foundInput = selectedProformaInputs[proformaInputToUpdate]?.find(input => input.type === newValuationInput.afterRepairValueType); // Try to find the previously selected afterRepairValueType in the newly update afterRepairValues radio array
        if (foundInput) { // If found, update with the newly calculated value
          newValuationInput.afterRepairValue = foundInput.value;
        } else { // If not found (i.e. user deselected all comps), clear both the value and type selection
          newValuationInput.afterRepairValue = null;
          newValuationInput.afterRepairValueType = null;
        }
      }

      yield all([
        put(setTransientValuationInputs(newValuationInput)), // to update proforma uw valuation input      
      ])
    }
  });
}